import { inject, Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Currency, Payment } from 'depoto-core/src/entities'
import { CoreService } from '../core.service'

@Injectable({ providedIn: 'root' }) // todo do i need this
export class PaymentService {
  private http = inject(HttpClient)
  core = inject(CoreService)

  public async getPayment(id, schema = { id: null, name: null }): Promise<Payment> {
    return new Payment(await this.core.services.payment.getById(id, schema))
  }

  async getPayments(
    parameters: any = {},
    schema: any = { id: null, name: null, type: { id: null } }
  ): Promise<{
    items: Payment[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.payment.getList(parameters, schema)
  }

  createPayment(payment: Partial<Payment>, schema: Partial<Payment>): Promise<Payment> {
    return this.core.services.payment.create(payment, schema)
  }

  updatePayment(payment: Partial<Payment>, schema: Partial<Payment>): Promise<Payment> {
    return this.core.services.payment.update(payment, schema)
  }

  deletePayment(payment: Partial<Payment>): Promise<Payment> {
    return this.core.services.payment.delete(payment)
  }

  async getPaymentTypes(params, schema = { id: null, name: null }) {
    return await this.core.services.payment.getPaymentTypes(params, { id: null, name: null })
    // .then(result => result.items)
  }

  async getCurrencies(
    parameters: any = {},
    schema: any = { id: null, name: null, ratio: null }
  ): Promise<{
    items: Currency[]
    paginator: { current: null; endPage: null; totalCount: null }
  }> {
    return await this.core.services.payment.getCurrencies(parameters, schema)
  }
}
